import { render, staticRenderFns } from "./DuplicateSession.vue?vue&type=template&id=33270eb5&"
import script from "./DuplicateSession.vue?vue&type=script&lang=ts&"
export * from "./DuplicateSession.vue?vue&type=script&lang=ts&"
import style0 from "./DuplicateSession.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports